import React, { memo } from 'react';

const SmsCode = ({ ...props }) => {
    return (
        <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.88 8C24.603 8 26 9.38 26 11.082v40.871c0 1.702-1.527 3.172-3.25 3.172H3.174C1.45 55.125 0 53.655 0 51.953V11.082C0 9.38 1.397 8 3.12 8h19.76zM13 49.177c-1.436 0-2.6 1.15-2.6 2.568 0 1.418 1.164 2.568 2.6 2.568 1.436 0 2.6-1.15 2.6-2.568 0-1.418-1.164-2.568-2.6-2.568zm0 .856c.957 0 1.733.633 1.733 1.578 0 .945-.776 1.846-1.733 1.846a1.723 1.723 0 01-1.733-1.712c0-.946.776-1.712 1.733-1.712zm11.375-37.158H1.625v35.75h22.75v-35.75zm-9.208-2.708H10.11v.722h5.056v-.722z"
                fill="#A9B1B9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.2 17.125H5.8c-.99 0-1.791.765-1.791 1.7L4 34.125l3.6-3.4h12.6c.99 0 1.8-.765 1.8-1.7v-10.2c0-.935-.81-1.7-1.8-1.7z"
                fill="#5A89FD"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28 51.125h34.723A1.28 1.28 0 0064 49.935v-2.4h-3.602V23.003c0-1.037-.769-1.878-1.717-1.878H28.013v2.401h29.985v24.009H28.013v3.25c0 .114-.005.228-.013.34z"
                fill="#A9B1B9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.923 29.125v3.5H28v7h6.923v3.5l7.077-7-7.077-7z"
                fill="#5A89FD"
            />
        </svg>
    );
};

export default memo(SmsCode);
